import dayjs from "dayjs";

export const formatDateWithDays = (createdAt) => {
  const formattedDate = dayjs(createdAt).format("DD-MM-YYYY");
  const diffDays = dayjs().diff(dayjs(createdAt), "day");
  return `${formattedDate} | ${diffDays} Days`;
};
